import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-3c0589f8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "anly-modal-header" }
const _hoisted_2 = { class: "anmly-title-header" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "anmly-header-separator" }, " . ", -1))
const _hoisted_4 = { class: "anmly-header-ellipsis-text" }
const _hoisted_5 = { class: "anly-header-actions" }
const _hoisted_6 = { class: "anly-side-bar-graph-box" }
const _hoisted_7 = {
  key: 1,
  class: "anly-graph-comp"
}
const _hoisted_8 = { class: "anly-multi-graph" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))

import { computed, ref, Ref, watch } from 'vue';
import MultiChartV3 from '@/components/charts/multi-chart-v3.vue';
import RexModalV3 from '@/rex-components/RexModalV3.vue';
import AnomalySideBar from '@/components/charts/utils/AnomalySideBar.vue';
// import GraphCustomLegends from '@/components/Common/GraphCustomLegends.vue';
import AnomalyGraphFooter from '@/components/charts/utils/AnomalyGraphFooter.vue';
import {
  GraphDataNamesEnum,
  GraphTypesEnum,
  AnomalyDataObjectType,
} from '@/components/Common/graph.types';
import { useI18n } from 'vue-i18n';
import {
  anomalyChartOptionsValues,
  ANNOTATION_RANGE,
  anomalyChartLegends,
  respFormatter,
} from '@/components/Common/graph.config';
import { useGraphData } from '@/components/Common/useGraphData';
import { useThemeToken } from '@/utils/theme/useThemeToken';
import { useStoreData } from '@/components/Common/useStoreData';
import {
  GetChartOptionsParamType,
  GraphTypes,
  ParamsType,
  Aggregation,
} from '@/components/Common/graph.types';
// import { LegendInfoType } from '@/components/Common/graph.types';
import { notificationError } from '@/utils/notification';
import { cloneDeep } from 'lodash';
import {
  graphTooltipKeys,
  anomalyInfoObject,
} from '@/components/charts/utils/utils.config';
import { GraphTooltipKeysType } from '@/components/charts/utils/utils.types';
import ForecastToggle from '@/components/IntegrationUtils/ForecastToggle.vue';
import ForecastDatePicker from '@/components/IntegrationUtils/ForecastDatePicker.vue';
import RexSkeletonV3 from '@/rex-components/RexSkeletonV3.vue';
import RexTooltipV3 from '@/rex-components/RexTooltipV3.vue';
import AnomalyGraphHeader from '@/components/charts/utils/AnomalyGraphHeader.vue';
import { useGraphActions } from '@/components/Common/useGraphActions';
import { RexConfigProvider } from '@/rex-components/rex.comp.config';

interface Props {
  title?: string;
  queryName: string;
  params?: ParamsType;
  chartOptionsData?: GetChartOptionsParamType;
  graphType?: GraphTypes;
  metricName: string;
  serviceName?: string;
  axisLabels: { x: string; y: string };
  aggregation?: Aggregation;
}

interface SelectedAnomalyType {
  keys: string[];
  info: AnomalyDataObjectType;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AnomalyInfoGraphModal',
  props: {
    title: {},
    queryName: {},
    params: { default: () => ({
    condition: {
      name: '',
      entity: {},
    },
    duration: {},
  }) },
    chartOptionsData: { default: () => anomalyChartOptionsValues },
    graphType: { default: GraphTypesEnum.FORECAST_WITH_ANOMALY },
    metricName: {},
    serviceName: { default: '' },
    axisLabels: {},
    aggregation: { default: () => ({ req: false }) }
  },
  emits: ['onClose'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const props = __props;

const { token } = useThemeToken();
const { t } = useI18n();
const { setIsForecastModalEnable, isForecastModalEnable, currentSideNav } =
  useStoreData();

const selectedAnomaly: Ref<SelectedAnomalyType> = ref({
  keys: [],
  info: anomalyInfoObject,
});
const multiChart: any = ref(null);

const legendList = ref(cloneDeep(anomalyChartLegends));
const tooltipInfo: Ref<GraphTooltipKeysType> = ref(graphTooltipKeys);
const anomalyInfo: Ref<AnomalyDataObjectType> = ref(anomalyInfoObject);
const graphType = ref(props.graphType);
const chartOptions = ref(props.chartOptionsData);
const aggregation = ref(props.aggregation);
const { data, isLoading, error, options, anomalyList, makegraphQLCall } =
  useGraphData(
    props.queryName,
    props.params,
    chartOptions,
    graphType,
    props.axisLabels,
    aggregation,
    // legendList,
  );

watch([error], () => {
  if (error) {
    notificationError(error.value?.message || t('errWhileFetchingData'));
  }
});

// function clearLegendSelection() {
//   legendList.value?.forEach((obj) => (obj.isActive = true));
// }

function onSelectAnomaly(selectedItem, itemInfo) {
  // clearLegendSelection();
  selectedAnomaly.value = { keys: selectedItem, info: itemInfo };
  anomalyInfo.value = anomalyList.value[selectedItem[0].split('-')[0]];
  const timeStamp = new Date(itemInfo.date).getTime();
  chartOptions.value = {
    ...chartOptions.value,
    annotationRange: [
      timeStamp - ANNOTATION_RANGE,
      timeStamp + ANNOTATION_RANGE,
    ],
  };
}

// const getActiveCount = computed(() =>
//   legendList.value?.reduce((acc, obj) => {
//     if (obj.isActive) acc++;
//     return acc;
//   }, 0),
// );

// function onLegendClick(obj: LegendInfoType, index: number) {
//   if (getActiveCount.value > 1 || !obj.isActive) {
//     multiChart.value?.chart?.toggleSeries?.(obj.label);
//     legendList.value[index].isActive = !obj.isActive;
//   }
// }

function onMouseMoveGraph(seriesArr) {
  let j = 0;
  legendList.value?.forEach((obj, i) => {
    tooltipInfo.value[GraphDataNamesEnum.TIMESTAMPS] = seriesArr[0]?.x;
    if (obj.isActive && obj.key in graphTooltipKeys) {
      if (obj.key === GraphDataNamesEnum.UPPER_THRESHOLD) {
        tooltipInfo.value[GraphDataNamesEnum.LOWER_THRESHOLD] =
          seriesArr[j]?.y?.[0];
        tooltipInfo.value[GraphDataNamesEnum.UPPER_THRESHOLD] =
          seriesArr[j]?.y?.[1];
      } else {
        tooltipInfo.value[obj.key] = seriesArr[j]?.y;
      }
    }
    if (obj.isActive) j++;
  });
}

function handleClose() {
  emit('onClose');
  Object.keys(graphTooltipKeys).forEach(
    (key) => (graphTooltipKeys[key] = null),
  );
}

function onForecastChange(data) {
  setIsForecastModalEnable(data);
}

function onDurationChange(duration) {
  selectedAnomaly.value.keys = [];
  selectedAnomaly.value.info = anomalyInfoObject;
  chartOptions.value.annotationRange = [];
  let params = {
    ...props.params,
    duration: duration,
  };
  makegraphQLCall(props.queryName, params, respFormatter(graphType.value));
  // clearLegendSelection();
}

const { handleZoomIn, handleZoomOut, handleReset } = useGraphActions(
  multiChart,
  graphType,
);

return (_ctx: any,_cache: any) => {
  const _component_BaseIcon = _resolveComponent("BaseIcon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(RexConfigProvider), { theme: {
        components: {
          Modal: {
            colorBgElevated: '#181a1d',
          },
        },
      } }, {
      default: _withCtx(() => [
        _createVNode(RexModalV3, {
          show: true,
          onOnClose: handleClose,
          width: "85vw",
          enableFooter: true,
          bodyStyle: {},
          headerStyle: { border: 'none' }
        }, {
          header: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", null, [
                  _createTextVNode(_toDisplayString(_ctx.title) + " ", 1),
                  _createVNode(_component_BaseIcon, {
                    name: "starFilled",
                    width: "1em",
                    height: "1em",
                    class: "anmly-header-icon-suffix"
                  })
                ]),
                _hoisted_3,
                _createVNode(RexTooltipV3, {
                  title: _ctx.serviceName,
                  class: "anmly-header-text"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.serviceName), 1)
                  ]),
                  _: 1
                }, 8, ["title"])
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(ForecastDatePicker, { onOnDurationChange: onDurationChange }),
                _createVNode(ForecastToggle, {
                  showForecastToggle: true,
                  isForcastEnabled: _unref(isForecastModalEnable),
                  onChange: onForecastChange
                }, null, 8, ["isForcastEnabled"])
              ])
            ])
          ]),
          body: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(AnomalySideBar, {
                class: "anly-side-bar",
                selectedItems: selectedAnomaly.value.keys,
                anomalyList: _unref(anomalyList),
                onOnSelect: onSelectAnomaly
              }, null, 8, ["selectedItems", "anomalyList"]),
              (_unref(isLoading))
                ? (_openBlock(), _createBlock(RexSkeletonV3, {
                    key: 0,
                    loading: _unref(isLoading),
                    paragraph: { rows: 8 },
                    class: "anly-modal-graph-loading-comp"
                  }, null, 8, ["loading"]))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(AnomalyGraphHeader, {
                      selectedAnomalyInfo: selectedAnomaly.value.info,
                      anomaliesList: _unref(anomalyList),
                      handleZoomOut: _unref(handleZoomOut),
                      handleZoomIn: _unref(handleZoomIn),
                      handleReset: _unref(handleReset),
                      actionsIdPrefix: _ctx.title || 'graph-action'
                    }, null, 8, ["selectedAnomalyInfo", "anomaliesList", "handleZoomOut", "handleZoomIn", "handleReset", "actionsIdPrefix"]),
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(MultiChartV3, {
                        series: _unref(data),
                        chartOptions: _unref(options),
                        ref_key: "multiChart",
                        ref: multiChart,
                        onOnMouseMove: onMouseMoveGraph
                      }, null, 8, ["series", "chartOptions"])
                    ]),
                    _createVNode(AnomalyGraphFooter, {
                      tooltipInfoData: tooltipInfo.value,
                      anomalyInfo: anomalyInfo.value,
                      isAnomalySelected: selectedAnomaly.value?.keys?.length > 0
                    }, null, 8, ["tooltipInfoData", "anomalyInfo", "isAnomalySelected"])
                  ]))
            ])
          ]),
          footer: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}
}

})